import ControlerCACP from "../Common/ControlerCACP";

export default ControlerCACP;